module.exports = __webpack_public_path__ + "img/logo.be39c008.png";